var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sync-panel sync-config-panel"
  }, [_vm.systemTabs.length ? _c('div', {
    staticClass: "config-system-tabs"
  }, _vm._l(_vm.systemTabs, function (item) {
    return _c('button', {
      key: item.value,
      class: {
        active: _vm.currentSystem === item.value
      },
      on: {
        "click": function ($event) {
          return _vm.selectConfigSystem(item.value);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.shortSystemName(item.value)) + ` ${$t("pewx2", "配置")} `)]);
  }), 0) : _vm._e(), _vm.currentSystem ? [_c('section', {
    staticClass: "config-card"
  }, [_c('div', {
    staticClass: "config-card-head"
  }, [_c('div', {
    staticClass: "config-card-title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-sync"
    }
  }), _vm._v(" " + _vm._s(_vm.shortSystemName(_vm.currentSystem)) + ` ${$t("b1wtk44", "同步状态")} `)], 1), _c('span', {
    staticClass: "config-status-tag",
    class: _vm.statusClass
  }, [_c('span'), _vm._v(" " + _vm._s(_vm.statusText) + " ")])]), _c('div', {
    staticClass: "config-card-body"
  }, _vm._l(_vm.statusRows, function (row) {
    return _c('div', {
      key: row.label,
      staticClass: "config-card-row"
    }, [_c('span', {
      staticClass: "config-row-label"
    }, [_vm._v(_vm._s(row.label))]), _c('span', {
      staticClass: "config-row-value",
      class: row.className
    }, [row.tag ? _c('span', {
      staticClass: "config-tag",
      class: row.tagClass
    }, [_vm._v(" " + _vm._s(row.value) + " ")]) : [_vm._v(_vm._s(row.value))]], 2)]);
  }), 0)]), _c('section', {
    staticClass: "config-card"
  }, [_c('div', {
    staticClass: "config-card-head"
  }, [_c('div', {
    staticClass: "config-card-title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-pulse"
    }
  }), _vm._v(` ${$t("cunp3p5", "连通性测试")} `)], 1), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.testing
    },
    on: {
      "click": _vm.testConnection
    }
  }, [_vm._v(` ${$t("je06m95", "测试连通性")} `)])], 1), _c('div', {
    staticClass: "config-card-body"
  }, [_vm.connectionResult ? _c('div', {
    staticClass: "config-connection-result",
    class: _vm.connectionResult.status
  }, [_c('Icon', {
    attrs: {
      "type": _vm.connectionResult.icon
    }
  }), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.connectionResult.title))]), _c('p', [_vm._v(_vm._s(_vm.connectionResult.message))])])], 1) : _vm._e(), _c('p', {
    staticClass: "config-tip"
  }, [_vm._v(_vm._s(_vm.connectionTip))])])]), _c('section', {
    staticClass: "config-card"
  }, [_c('div', {
    staticClass: "config-card-head"
  }, [_c('div', {
    staticClass: "config-card-title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-search"
    }
  }), _vm._v(" " + _vm._s((_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("cclircm", "\u4E3B\u52A8\u67E5\u8BE2 ${shortName} \u4E1A\u52A1\u7CFB\u7EDF", {
    "shortName": _vm.shortName
  }))) + " ")], 1), _c('span', {
    staticClass: "config-card-desc"
  }, [_vm._v(" " + _vm._s(`${_vm.shortName}${" " + $t('jjwbbsj', '提供给 iWork 的账号查询接口地址') + ""}`) + " ")])]), _c('div', {
    staticClass: "config-card-body"
  }, [_c('div', {
    staticClass: "config-query-row"
  }, [_c('span', {
    staticClass: "config-row-label"
  }, [_vm._v(" " + _vm._s(`${_vm.shortName}${" " + $t('dopuez4', '查询接口') + ""}`) + " ")]), _c('Input', {
    staticClass: "config-query-input",
    attrs: {
      "placeholder": $t("tuxuezb", "请输入账号查询接口地址")
    },
    model: {
      value: _vm.queryUrl,
      callback: function ($$v) {
        _vm.queryUrl = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "queryUrl"
    }
  }), _c('Button', {
    attrs: {
      "loading": _vm.autoFetching,
      "disabled": !_vm.currentSystem
    },
    on: {
      "click": _vm.autoFetchQueryUrl
    }
  }, [_vm._v(` ${$t("gqmr994", "自动获取")} `)]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saving,
      "disabled": !_vm.currentSystem
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v(` ${$t("e32z2", "保存")} `)])], 1), _vm.showIHotelQueryNotice ? _c('div', {
    staticClass: "config-query-notice"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle-outline"
    }
  }), _c('span', [_vm._v($t("29le471e", "私有化部署下，查询接口需客户内网放行 iWork 出站访问（或绿云运维侧专网通道）；否则查询不可达。"))])], 1) : _vm._e(), _c('p', {
    staticClass: "config-tip"
  }, [_vm._v(_vm._s(_vm.queryTip))])])])] : _c('div', {
    staticClass: "sync-empty-card"
  }, [_vm._v($t("dcv57g4", "暂无数据"))])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };